import { PageScaffold } from "../../shared/ui/PageScaffold";

const publicLinks = [
  { to: "/t/:tenantSlug", label: "公開トップ" },
  { to: "/t/:tenantSlug/schedule", label: "公開スケジュール" },
  { to: "/t/:tenantSlug/events", label: "公開イベント" }
];

export function PublicEventDetailPage() {
  return (
    <PageScaffold
      title="Public Event Detail"
      description="公開イベント詳細のプレースホルダーです。"
      links={publicLinks}
    >
      <p>ここに event 詳細表示を実装します。</p>
    </PageScaffold>
  );
}
